exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".single-level-row[data-v-714f7929]{cursor:pointer}", ""]);

// exports
